module.exports = __webpack_public_path__ + "0b99cf00b84ee9226b0d07e7d59c2d41.pdf";